module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Widget":{"handlerDom.titleMove":[{"value":function (elem) {
var delta;
var time;
var velo = 80;
var title = $(elem).find('a');
var layoutBox = $(elem).width();
var layoutTitle = title.width();
if(layoutTitle > layoutBox){
delta	= layoutBox - layoutTitle;
time	= delta/velo*(-1000);
delta/velo*(-1) > 1 ? time : time = 500;
$(title).animate({"left": delta + "px"}, time);
}
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101016},"path":"~.Widget","_fox_":1}],"handlerDom.titleMoveBack":[{"value":function (elem) {
var title = $(elem).find('a');
time = 500;
$(title).stop(true).animate({"left": "0px"}, time);
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101021},"path":"~.Widget","_fox_":1}]},"~.AdvancedList":{"dontReuseSn":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101023},"path":"~.AdvancedList","_fox_":1}]},"@root":{"widgets.sestaFosta.widget":[{"value":"SestaFosta_Popup","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101027},"path":"@root","_fox_":1}]},"@root .Layout_Home":{"widgets.expremiumUser.widget":[{"value":"ExpremiumUser_Popup","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101031},"path":"@root .Layout_Home","_fox_":1}]},"~#textPersonal":{"hooks.onStartInit":[{"value":function () {
var siteName = document.location.host;
this.setTemplateOptions({ siteName: siteName });
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101037},"path":"~#textPersonal","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/common.js
// module id = 642
// module chunks = 4